export default "__VITE_ASSET__DcbXx1Lc__"